import { render, staticRenderFns } from "./SimpleResponse.vue?vue&type=template&id=2e321d6d&scoped=true"
import script from "./SimpleResponse.vue?vue&type=script&lang=js"
export * from "./SimpleResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e321d6d",
  null
  
)

export default component.exports